import { Component, NgModule, OnInit,ViewEncapsulation } from '@angular/core';
import { AppSettings } from '@app/common/app-setting';
import { Router} from '@angular/router'
import {Location} from '@angular/common'
import { DomSanitizer,SafeUrl,SafeResourceUrl } from '@angular/platform-browser';
declare var device;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None
})

//for mobile app

export class AppComponent implements OnInit {
  
   
  title = 'app';
  changeDynamicCss : boolean = AppSettings.changeDynamicCss;

  ColorUrlName : string = "./../assets/styles/utils/colors.css";
  ColorUrl : SafeResourceUrl
  AcquirerId:string;

  constructor(    
    private location: Location,public sanitizer: DomSanitizer) {

    
    }   
    ngOnInit() {
      this.ChangeColourForAcquirer(false);
  
      //for mobile app 
      document.addEventListener("deviceready", function() { 
      alert(device.platform); 
      }, false); 
      
    }  

    public ChangeColourForAcquirer(forceToDefault : boolean)
    {
      if(this.changeDynamicCss)
      {
      if(forceToDefault)
      {
        this.ColorUrlName = "./../assets/styles/utils/colors.css";
      }
      else if(localStorage != null && localStorage.getItem('AcquirerId') != null){
        // debugger;
        this.AcquirerId = localStorage.getItem('AcquirerId');
        this.ColorUrlName = "./../assets/styles/utils/colors" + this.AcquirerId + ".css";
       
      }    
     
       this.ColorUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.ColorUrlName);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts